import { get } from "@/apis";
import router from "@/router";
import { parseErrorMessage } from "@/utils/util";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    alias: 0,
    configLoaded: false,
    config: {
      id: 0,
      activityId: 0,
      systemName: "",
      systemNameEn: "",
      activationType: null,
      verifyMode: null,
      conditions: [],
      requiresOnlineVerification: null,
      enterUrl: "",
      systemDescription: "",
      activationTip: "",
      completionTip: "",
      isShowModal: null,
      modalTitle: "",
      modalContent: "",
      modalConfirmButtonText: "",
      modalCancelButtonText: "",
      modalConfirmButtonColor: "",
      modalCancelButtonColor: "",
      modalBackgroundColor: "",
      modalTextColor: "",
      modalConfirmButtonTextColor: "",
      modalCancelButtonTextColor: "",
      modalConfirmButtonEnterUrl: "",
      modalWindowTarget: "",
      isShowQrCode: "",
      banner: "",
      footer: "",
      systemPrimaryColor: "",
      systemInverseColor: "",
    },
  },
  mutations: {
    SET_ALIAS(state, payload) {
      state.alias = payload;
    },
    SET_CONFIG(state, payload) {
      state.config = payload;
    },
    SET_CONFIG_LOADED(state, payload) {
      state.configLoaded = payload;
    },
  },
  getters: {
    getConfig: (state) => {
      return state.config;
    },
    getConfigLoaded: (state) => {
      return state.configLoaded;
    },
  },
  actions: {
    async setConfig(context, data) {
      message.open({
        content: "配置加载中...",
        type: "loading",
        duration: 1,
      });
      const { alias } = data;
      const res = await get(`/api/ActivationWeb/GetConfig?alias=${alias}`);
      if (res.code == 200 && res.success) {
        // 设置系统主色
        document.documentElement.style.setProperty(
          "--primary-color",
          res.data.systemPrimaryColor
        );
        // 设置系统反色
        document.documentElement.style.setProperty(
          "--primary-inverse-color",
          res.data.systemInverseColor
        );

        document.title = `${res.data.systemName} - ${res.data.systemNameEn}`;

        context.commit("SET_ALIAS", res.data.id);
        context.commit("SET_CONFIG", res.data);
      } else {
        var pem = parseErrorMessage(res.message);
        if (!!pem) {
          router.push(`/error?title=[${pem.code}]&msg=${pem.message}`);
        }
      }
    },
    setConfigLoaded(context, data) {
      context.commit("SET_CONFIG_LOADED", data);
    },
  },
};
